import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  getLocationStock,
  getLocationStockHistory,
  locationStockLogs,
  locationStockTransaction,
} from "data/server_apis/inventoryService";

const locationStockAdapter = createEntityAdapter({
  selectId: (locationStock) => locationStock.id,
});

const locationStockLogAdapter = createEntityAdapter({
  selectId: (log) => log.id,
});

export const locationStockTransactionThunk = createAsyncThunk(
  "locationStock/create",
  async ({ stock, data }, { rejectWithValue }) => {
    try {
      return (await locationStockTransaction(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
export const getLocationStockLogsThunk = createAsyncThunk(
  "locationStockLogs/get",
  async ({page,from_date,to_date,location}, { rejectWithValue }) => {
    try {
      return (await locationStockLogs(page,from_date,to_date,location)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getLocationStockThunk = createAsyncThunk(
  "locationStock/get",
  async (location, { rejectWithValue }) => {
    try {
      return (await getLocationStock(location)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getLocationStockHistoryThunk = createAsyncThunk(
  "locationStockHistory/get",
  async ({time,location}, { rejectWithValue }) => {
    try {
      return (await getLocationStockHistory(time,location)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
const locationStockSlice = createSlice({
  name: "locationStack",
  initialState: locationStockAdapter.getInitialState({
    locationStockStatus: {},
    locationStockTransactionStatus: {},
    logs: locationStockLogAdapter.getInitialState(),
    logStatus: {},
    logPageCount: 1,
    history: [],
    historyStatus: {},
  }),
  reducers: {
    resetStat : (state,action)=>{
      state.locationStockTransactionStatus = { };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(locationStockTransactionThunk.pending, (state, action) => {
        state.locationStockTransactionStatus = { loading: "post" };
      })
      .addCase(locationStockTransactionThunk.rejected, (state, action) => {
        state.locationStockTransactionStatus = {
          error: "post",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(locationStockTransactionThunk.fulfilled, (state, action) => {
        state.locationStockTransactionStatus = {
          success: "post",
          errorMessage: action.payload?.message,
        };
        if (action.meta.arg.data.in_or_out === "ret" || action.meta.arg.data.in_or_out === "out" || action.meta.arg.data.in_or_out === "rem") {
          const stock = { ...action.meta.arg.stock };
          stock.qty -= action.payload.qty;
          locationStockAdapter.updateOne(state, {
            id: action.meta.arg.stock.id,
            changes: stock,
          });
        }
      });

    builder
      .addCase(getLocationStockThunk.pending, (state, action) => {
        state.locationStockStatus = { loading: "get" };
      })
      .addCase(getLocationStockThunk.rejected, (state, action) => {
        state.locationStockStatus = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getLocationStockThunk.fulfilled, (state, action) => {
        state.locationStockStatus = {
          success: "get",
        };
        locationStockAdapter.setAll(state, action.payload);
      });

    builder.addCase(getLocationStockLogsThunk.fulfilled, (state, action) => {
      locationStockLogAdapter.setAll(state.logs, action.payload.results);
      state.logPageCount = action.payload.total_pages;
    });

    builder
      .addCase(getLocationStockHistoryThunk.pending, (state, action) => {
        state.getMainStockHistory = { loading: "get" };
      })
      .addCase(getLocationStockHistoryThunk.rejected, (state, action) => {
        state.getMainStockHistory = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getLocationStockHistoryThunk.fulfilled, (state, action) => {
        state.getMainStockHistory = {
          success: "get",
        };
        state.history = action.payload;
      });
  },
});

export const {resetStat} = locationStockSlice.actions;
export const locationStockSelector = locationStockAdapter.getSelectors(
  (state) => state.locationStock
);

export const locationStockLogSelector = locationStockLogAdapter.getSelectors(
  (state) => state.locationStock.logs
);

export default locationStockSlice.reducer;
